import { render, staticRenderFns } from "./PaymentAlertSettings.vue?vue&type=template&id=140f5732&scoped=true"
import script from "./PaymentAlertSettings.vue?vue&type=script&lang=js"
export * from "./PaymentAlertSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentAlertSettings.vue?vue&type=style&index=0&id=140f5732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f5732",
  null
  
)

export default component.exports